// Centralized structural data for the portfolio (text lives in i18n)

export const aboutMe = {
  name: "Moustapha Sambe",
  location: "Villejuif, 94800",
  phone: "+33 7 53 84 81 57",
  email: "moustaphasamb719@gmail.com",
  social: {
    github: "https://github.com/taphacoobams",
    linkedin: "https://linkedin.com/in/mmsambe",
  },
};

export const skillCategories = [
  { id: "programmingLanguages", icon: "fa-code", color: "primary" },
  { id: "dataAndAI", icon: "fa-chart-line", color: "secondary" },
  { id: "databases", icon: "fa-database", color: "secondary" },
  { id: "webTechnologies", icon: "fa-globe", color: "primary" },
  { id: "devOpsAndCloud", icon: "fa-gears", color: "primary" },
  { id: "softSkills", icon: "fa-users", color: "primary", isSoftSkills: true },
] as const;

export type SkillCategoryId = (typeof skillCategories)[number]["id"];

export const skills: Record<
  Exclude<SkillCategoryId, "softSkills">,
  string[] | { name: string; percentage: number }[]
> & { softSkillKeys: readonly string[] } = {
  programmingLanguages: [
    { name: "Python", percentage: 90 },
    { name: "SQL", percentage: 85 },
    { name: "JavaScript", percentage: 80 },
    { name: "TypeScript", percentage: 80 },
    { name: "Java", percentage: 75 },
    { name: "DataWeave", percentage: 75 },
  ],
  dataAndAI: [
    "Pandas",
    "NumPy",
    "Scikit-learn",
    "TensorFlow",
    "Power BI",
    "Machine Learning",
    "ETL",
    "Data Pipeline",
    "Data Analysis",
    "SHAP",
    "XGBoost",
    "Random Forest",
  ],
  webTechnologies: [
    "React",
    "Node.js",
    "FastAPI",
    "API REST",
    "Symfony",
    "GraphQL",
    "Tailwind CSS",
  ],
  databases: ["MySQL", "PostgreSQL", "MongoDB", "Firebase", "Neon DB"],
  devOpsAndCloud: [
    "Docker",
    "Git",
    "GitHub",
    "Linux",
    "Airflow",
    "Maven",
    "Nginx",
    "Jenkins",
    "GitLab",
    "CloudHub",
  ],
  softSkillKeys: [
    "teamwork",
    "autonomy",
    "curiosity",
    "rigor",
    "creativity",
    "adaptability",
    "communication",
  ],
};

export const experiences = [
  {
    id: 1,
    key: "cap4lab",
    company: "CAP4LAB, Paris",
    isList: true,
  },
];

export const education = [
  {
    id: 1,
    key: "esgiMaster",
    period: "2026 - 2028",
    institution: "ESGI, Paris",
  },
  {
    id: 2,
    key: "estiamMaster",
    period: "2023 - 2025",
    institution: "ESTIAM, Paris",
  },
  {
    id: 3,
    key: "epsiBachelor",
    period: "2020 - 2023",
    institution: "EPSI, Paris",
  },
];

export { projects as portfolioProjects } from "./projects.ts";
